import type { FunctionComponent } from "react";
import { JobItem } from "@kanda-libs/ks-frontend-services";
import useLineItemContextProps from "components/job/LineItem/LineItemContext/useLineItemContextProps";
import CustomQuote from "components/job/LineItem/CustomQuote";
import LineItemContext from "components/job/LineItem/LineItemContext";
import KandaQuote from "components/job/LineItem/KandaQuote";

export interface LineItemProps {
  lineItem: JobItem;
  variant: string;
}

const LineItem: FunctionComponent<LineItemProps> = ({ lineItem, variant }) => {
  const { kanda, ...props } = useLineItemContextProps(lineItem, variant);

  return (
    <LineItemContext.Provider value={props}>
      {kanda ? <KandaQuote /> : <CustomQuote />}
    </LineItemContext.Provider>
  );
};

export default LineItem;
